import { AwardsApi } from '../clients';
import { mapUserCyclesPage } from '../mappers';

export const getUserCycles = async (userId, page = 1) =>
  mapUserCyclesPage(await AwardsApi.getUserCycles(userId, page));
